import { render, staticRenderFns } from "./assignPageRole.vue?vue&type=template&id=49c0014b&lang=pug&"
import script from "./assignPageRole.vue?vue&type=script&lang=js&"
export * from "./assignPageRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports